import React from "react";

import { SocialMediaIcon as Value } from "@reactivated";

import { concatClassNames } from "../../utils/styles";
import { Svg } from "../Svg";

import styles from "./index.module.scss";

export const iconNameMap: { [key in NonNullable<Value["icon"]>]: string } = {
    twitter: "Twitter",
    facebook: "Facebook",
    youtube: "YouTube",
    linkedin: "LinkedIn",
    instagram: "Instagram",
    tiktok: "TikTok",
    pinterest: "Pinterest",
};

export const SocialMediaIcon = (props: {
    value: Value;
    className?: string;
    useLegacyTwitterLogo?: boolean;
}) => {
    if (!props.value.link || !props.value.icon) {
        return null;
    }
    const name =
        props.useLegacyTwitterLogo && props.value.icon === "twitter"
            ? "twitter-bird"
            : props.value.icon;
    return (
        <a
            href={props.value.link}
            target="_blank"
            rel="noreferrer"
            className={concatClassNames([styles.icon, props.className])}
        >
            <Svg
                data-icon={name}
                name={name}
                visuallyHiddenText={iconNameMap[props.value.icon]}
            />
        </a>
    );
};

export const SocialMediaIconList = (props: {
    value: Value[];
    className?: string;
}) => {
    return (
        <div className={concatClassNames([styles.iconList, props.className])}>
            {props.value.map((value) => (
                <SocialMediaIcon key={value.icon} value={value} />
            ))}
        </div>
    );
};
